<header class="w-100 bg-dark py-3 px-4">
  <div class="container">
    <img src="" alt="Unipay" style="height: 2rem; width: auto;" />
  </div>
</header> 